/* eslint-disable @typescript-eslint/no-namespace */

import { IUser } from '@shs-digi-care-monorepo/interfaces';
import { BaseUserUpdatePayload, ICreateOrUpdateUserPayload, PatchUserSettings } from '../../services';

export namespace UserActions {
    /**
     * Loads the current authenticated user.
     * This should be dispatched once during app initialization.
     */
    export class LoadMe {
        public static readonly type = '[User] Load Me';
    }

    /**
     * Sets the current user in the store.
     */
    export class SetMe {
        public static readonly type = '[User] Set Me';
        constructor(public user: IUser) {}
    }

    /**
     * Clears the current user from the store.
     */
    export class Clear {
        public static readonly type = '[User] Clear';
    }

    /**
     * Loads a paginated list of the users the requestor administers.
     */
    export class LoadUsers {
        public static readonly type = '[User] Load Users';
        constructor(
            public payload: {
                page: number;
                pageSize: number;
                searchTerm?: string;
                teamId?: string;
                availableFrom?: string;
                availableTo?: string;
            }
        ) {}
    }

    /**
     * Loads users by team ID.
     */
    export class LoadUsersByTeam {
        public static readonly type = '[User] Load Users By Team';
        constructor(public teamId: string) {}
    }

    /**
     * Loads a user by their GID.
     */
    export class LoadUserByGid {
        public static readonly type = '[User] Load User By Gid';
        constructor(public gid: string) {}
    }

    /**
     * Creates a new user.
     */
    export class CreateUser {
        public static readonly type = '[User] Create User';
        constructor(public user: ICreateOrUpdateUserPayload) {}
    }

    /**
     * Updates an existing user.
     */
    export class UpdateUser {
        public static readonly type = '[User] Update User';
        constructor(public user: ICreateOrUpdateUserPayload) {}
    }

    /**
     * Deletes a user by their GID.
     */
    export class DeleteUser {
        public static readonly type = '[User] Delete User';
        constructor(public gid: string) {}
    }

    /**
     * Patches the current user's profile.
     */
    export class PatchMe {
        public static readonly type = '[User] Patch Me';
        constructor(public patch: Partial<BaseUserUpdatePayload>) {}
    }

    /**
     * Loads the current user's settings.
     */
    export class LoadUserSettings {
        public static readonly type = '[User] Load User Settings';
    }

    /**
     * Updates the current user's settings.
     */
    export class UpdateUserSettings {
        public static readonly type = '[User] Update User Settings';
        constructor(public settings: PatchUserSettings) {}
    }
}
